"use client";
import FormGroup, { type FormGroupProps } from "@mui/material/FormGroup";
import FormFieldWrapper, {
  type FormFieldWrapperProps,
} from "@/components/common/formElements/library/FormFieldWrapper";

export interface CheckboxGroupProps
  extends Omit<FormFieldWrapperProps, "testId">,
    Pick<FormGroupProps, "row"> {}

export default function CheckboxGroup(props: CheckboxGroupProps) {
  const { row, children, ...formFieldWrapperProps } = props;

  return (
    <FormFieldWrapper {...formFieldWrapperProps} testId="checkbox-group">
      <FormGroup row={row}>{children}</FormGroup>
    </FormFieldWrapper>
  );
}
